/* eslint-disable @typescript-eslint/no-explicit-any */
// FIXME: fix any
import { Skeleton } from '@/components/ui/skeleton';
import usePromise from '@/hooks/usePromise';
import { entityConfigs, EntityType } from '@/lib/entities/entityConfig';
import { useMemo } from 'react';

interface ForeignKeyCellProps {
  value: any | any[];
  entityType: EntityType;
  multiple?: boolean;
}

export function ForeignKeyCell({
  value,
  entityType: entityType,
  multiple = false,
}: ForeignKeyCellProps) {
  if (!value) {
    return <span className="text-muted-foreground">-</span>;
  }
  if (multiple && Array.isArray(value)) {
    if (value.length === 0) {
      return <span className="text-muted-foreground">-</span>;
    }
    return (
      // ???: how to handle many entities
      <div className="flex flex-wrap gap-1">
        {value./* slice(0, 3). */ map((id) => {
          return <ForeignKeyEntity value={id} entityType={entityType} />;
        })}
        {/* {value.length > 3 && (
          <Badge variant="secondary" className="text-xs">
          +{value.length - 3}
          </Badge>
          )} */}
      </div>
    );
  }
  return <ForeignKeyEntity entityType={entityType} value={value} />;
}

interface ForeignKeyEntityProps {
  value: any;
  entityType: EntityType;
}

export function ForeignKeyEntity({
  value,
  entityType: entityType,
}: ForeignKeyEntityProps) {
  const entityConfig = entityConfigs[entityType];
  // TODO: use queryClient

  const entity = usePromise(
    useMemo(
      () => entityConfig.getById(value),
      [value, entityConfig],
    ) as Promise<any>,
  );

  return entity ? entityConfig.renderBadge(entity as any) : <Skeleton />;
}
